import { useDispatch } from 'react-redux'
import { setCurrentPaginationConfig } from 'store/AppState/actions'

export const useHandleChangeRows = () => {
  const dispatch = useDispatch()

  const handleChangeRows = (event, goToPage, screen) => {
    const per = Number(event?.target?.value) ?? 25
    const page = 1

    dispatch(
      setCurrentPaginationConfig({
        screen,
        page,
        per,
      })
    )

    // required function to update paginationCoordinator
    goToPage(page, per)
  }

  return handleChangeRows
}
